export const ISSUERS_ENTITY = [
  {
    key: 'type',
    displayValue: 'Type',
  },
  {
    key: 'entityName',
    displayValue: 'Entity Name',
  },
  {
    key: 'lei',
    displayValue: 'LEI',
  },
  {
    key: 'fitchRating',
    displayValue: 'Fitch Rating',
  },
  {
    key: 'moodysRating',
    displayValue: "Moody's Rating",
  },
  {
    key: 'spRating',
    displayValue: 'S&P Rating',
  },
];
